import Img from '@/components/Img';
import styles from './ImageWithHTML.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import Icon from '@/components/Icon';
import Text from '@/components/Text/Text';

export interface ImageWithListProps {
  title: string;
  description: string;
  image: Image;
  button: IButton
}

interface Image {
  height: number,
  width: number,
  url: string
}

interface IButton {
  id: number,
  title: string,
  type: ButtonType,
  link: string
}

export interface CheckmarkItem {
  id: number;
  text: string;
}

export interface BasicListItem {
  id: number;
  title: string;
  list: { text: string }[]
}

export interface ImageCard {
  id: number;
  title: string;
  description: string;
  subtitle: string;
  icon: Image;
  button: IButton;
  basicLists: BasicListItem[];
  checkmarkList: CheckmarkItem[];
}

export interface TechnologySection {
  __component: string;
  id: number;
  cards: ImageCard[];
}

const CheckmarkList = ({ items }: { items: ImageCard['checkmarkList'] }) => (
  <ul className={styles.checkmarkList}>
    {items.map((item) => (
      <li key={item.id}>
        <Icon
          name='check'
          style={{ fontSize: 24 }}
          aria-hidden
        />
        <span>{item.text}</span>
      </li>
    ))}
  </ul>
);

const BasicList = ({ lists }: { lists: ImageCard['basicLists'] }) => (
  <div className={styles.basicListWrapper}>
    {lists.map((parent) => (
      <div key={parent.id}>
        <p className={styles.basicList_title}>{parent.title}</p>
        {parent.list.length > 0 && (
          <ul className={styles.basicList}>
            {parent.list.map((item) => (
              <li key={item.text}>{item.text}</li>
            ))}
          </ul>
        )}
      </div>
    ))}
  </div>
);

const Card = ({ card }: { card: ImageCard }) => (
  <div className={styles.card}>
    <div className={styles.imageWithListContent}>
      <p className={styles.tagline}>{card.subtitle}</p>
      <div className={styles.textContent}>
        <Text tag='h2'>{card.title}</Text>
        <div
          dangerouslySetInnerHTML={{ __html: card.description }}
          className={styles.description}
        />
      </div>

      {card.checkmarkList.length > 0 && <CheckmarkList items={card.checkmarkList} />}
      {card.basicLists.length > 0 && <BasicList lists={card.basicLists} />}

      {card.button && (
        <Button
          type={card.button.type}
          className={styles.primaryButton}
          iconName='arrow_forward'
          href={card.button.link}
        >
          {card.button.title}
        </Button>
      )}
    </div>
    {card.icon && (
      <Img
        src={card.icon.url}
        className={styles.image}
        height={card.icon.height}
        width={card.icon.width}
        alt={card.title}
      />
    )}
  </div>
);

const ImageWithList = ({ data }: { data: TechnologySection }) => (
  <section className={styles.imageWithList}>
    {data.cards.map((card) => (
      <Card
        key={card.id}
        card={card}
      />
    ))}
  </section>
);

export default ImageWithList;
